/**
 * Check wether a routeable component defines `methodName`.
 * Check recursively until method is implemented OR
 * the component does not define a WrappedComponent property.
 */
function getDataDependency(component, methodName) {
  if (typeof component[methodName] === 'function') {
    return component[methodName];
  }

  if (component.WrappedComponent) {
    return getDataDependency(component.WrappedComponent, methodName);
  }

  return null;
}

export default getDataDependency;